import { useParams } from "react-router-dom";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useCart } from "../Context/CartContext";
import "./ProductPage.css";
import { useEffect, useState } from "react";

import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function ProductPage() {
  const { id } = useParams();
  const { addToCart } = useCart();

  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    const fetchProduct = async () => {
      const docRef = doc(db, "products", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = { id: docSnap.id, ...docSnap.data() };
        setProduct(data);

        if (data.images?.length) {
          setSelectedImage(data.images[0]);
        }
      }
    };

    fetchProduct();
  }, [id]);

  if (!product) {
    return <h2>Loading product...</h2>;
  }

  const handleAddToCart = () => {
    addToCart({ ...product, qty });
  };

  return (
    <section className="product-page">
      <div className="product-main">
        {/* IMAGE SECTION */}

        <div className="product-image-section">

          {product.images?.length > 1 && (
            <div className="thumbnail-list">
              {product.images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={product.name}
                  className={`thumbnail ${
                    selectedImage === img ? "active" : ""
                  }`}
                  onClick={() => setSelectedImage(img)}
                />
              ))}
            </div>
          )}

          <div className="main-image">
            <img src={selectedImage} alt={product.name} />
          </div>

        </div>

        {/* PRODUCT DATA */}

        <div className="product-data">
          <h1>{product.name}</h1>

          <div className="product-price">
            ₹{product.price}
            <span className="oldprice">₹{product.oldprice}</span>
          </div>

          <div className="product-quantity">

            <div
              className="minus"
              onClick={() => setQty((q) => Math.max(1, q - 1))}
            >
              <FaMinus />
            </div>

            <div className="quantity">{qty}</div>

            <div className="plus" onClick={() => setQty((q) => q + 1)}>
              <FaPlus />
            </div>

          </div>

          <div className="addorbuy">
            <button className="add" onClick={handleAddToCart}>
              Add to Cart
            </button>

            <button className="buy">Buy Now</button>
          </div>

          <div className="gift">
            <p>Gift-wrap available.</p>
          </div>
        </div>
      </div>

      <div className="product-description">
        <h4>Product Description :</h4>
        <p>Fresh flowers perfect for gifting and special occasions.</p>
      </div>
    </section>
  );
}